module.exports = __webpack_public_path__ + "static/media/a.2a58bb82.jpg";